import styled from 'styled-components'

import { media } from 'components/presentational'
import { LastPhotoSvg as LastPhotoSvgComponent } from 'components/presentational/svg/LastPhotoSvg'

export const LastPhotoSvg = styled(LastPhotoSvgComponent)`
  ${media.phone`
    width: 80px;
    height: 80px;
  `};
`
